import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import { testimonials, aboutStats, milestones } from '@/mocks/testimonials';

export default function AboutPage() {
  const aboutLD = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    'name': '关于韩漫之家 - 免费韩漫阅读平台',
    'description': '韩漫之家成立于2018年，是国内领先的免费韩漫在线阅读平台。我们拥有超过10万部高清韩国漫画资源，致力于为漫画爱好者提供优质的下拉式阅读体验。',
    'url': 'http://dnchemical.com/about',
    'isPartOf': { '@type': 'WebSite', 'name': '韩漫之家', 'url': 'http://dnchemical.com/' },
  };

  const orgLD = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': '韩漫之家',
    'alternateName': 'HanMan Home',
    'url': 'http://dnchemical.com/',
    'description': '国内领先的免费韩漫在线阅读平台，提供高清韩国漫画大全资源',
    'foundingDate': '2018',
    'email': 'hello@dnchemical.com',
    'address': {
      '@type': 'PostalAddress',
      'addressLocality': '上海市',
      'addressRegion': '浦东新区',
      'addressCountry': 'CN',
    },
    'contactPoint': [
      {
        '@type': 'ContactPoint',
        'email': 'hello@dnchemical.com',
        'contactType': 'Customer Service',
        'availableLanguage': ['Chinese'],
      },
      {
        '@type': 'ContactPoint',
        'email': 'hello@dnchemical.com',
        'contactType': 'Business Cooperation',
        'availableLanguage': ['Chinese', 'Korean'],
      },
    ],
    'sameAs': [
      'http://dnchemical.com/',
    ],
  };

  const breadcrumbLD = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'http://dnchemical.com/' },
      { '@type': 'ListItem', 'position': 2, 'name': '关于我们', 'item': 'http://dnchemical.com/about' },
    ],
  };

  const faqLD = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': '韩漫之家是免费的吗？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '是的，韩漫之家所有漫画资源均为免费阅读，用户无需付费即可畅享10万+高清韩漫资源。',
        },
      },
      {
        '@type': 'Question',
        'name': '漫画更新频率如何？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '韩漫之家每日更新300+章节，热门漫画持续追更，确保读者第一时间看到最新内容。',
        },
      },
      {
        '@type': 'Question',
        'name': '支持哪些设备阅读？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '韩漫之家采用响应式设计，支持电脑、平板、手机等多种设备。下拉式阅读设计让手机阅读体验特别流畅。',
        },
      },
      {
        '@type': 'Question',
        'name': '如何联系我们？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '您可以通过邮箱 hello@dnchemical.com 联系我们的客服团队，我们提供7×24小时在线服务。商务合作请发送至 hello@dnchemical.com。',
        },
      },
      {
        '@type': 'Question',
        'name': '网站有哪些漫画类型？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '韩漫之家涵盖恋爱甜宠、热血动作、惊悚悬疑、奇幻冒险、搞笑日常、都市情感、恐怖灵异、古风历史、治愈日常等丰富类型，满足不同读者的需求。',
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title="关于我们 - 免费韩漫下拉式在线阅读平台 - 韩漫之家"
        description="韩漫之家成立于2018年，是国内领先的免费韩漫在线阅读平台。我们拥有超过10万部高清韩国漫画资源，致力于为漫画爱好者提供优质的下拉式阅读体验。"
        keywords="韩漫之家,免费韩漫,韩国漫画,关于韩漫之家,漫画平台介绍"
        canonicalUrl="http://dnchemical.com/about"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutLD) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgLD) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLD) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLD) }} />
      <Navbar />
      <main>
        <section className="relative pt-16">
          <div className="bg-secondary-50 py-16 md:py-24">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6" aria-label="breadcrumb">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <span>/</span>
                <span className="text-foreground-600">关于我们</span>
              </nav>

              <div className="text-center max-w-3xl mx-auto">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
                  关于我们
                </span>
                <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
                  韩漫之家
                  <span className="block text-2xl md:text-3xl text-foreground-400 mt-2">免费韩国漫画平台</span>
                </h1>
                <p className="mt-5 text-sm text-foreground-500 leading-relaxed max-w-xl mx-auto">
                  自2018年成立以来，韩漫之家始终致力于为中文读者提供最优质的免费韩国漫画在线阅读服务，以高清画质和流畅的下拉式阅读体验赢得千万用户信赖。
                </p>
                <div className="mt-8 flex flex-wrap justify-center gap-8 md:gap-12">
                  {['正版资源', '高清画质', '每日更新', '永久免费'].map((tag) => (
                    <span key={tag} className="text-sm font-medium text-foreground-600 whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
                {aboutStats.map((stat) => (
                  <div key={stat.label} className="text-center p-6 rounded-lg bg-background-50">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                  品牌故事
                </h2>
                <p className="mt-6 text-sm text-foreground-600 leading-relaxed">
                  韩漫之家诞生于一群对韩国漫画充满热情的年轻人。我们深知漫画爱好者寻找优质免费韩漫的不易，因此创立了这个平台，希望能让更多中文读者方便地欣赏到高质量的韩国漫画。
                </p>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                  我们的团队由资深漫画编辑、技术开发者和内容运营专家组成，每天都在为提升用户的阅读体验而努力。从漫画资源的筛选到阅读器性能的优化，每一个细节都倾注了我们的心血。
                </p>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                  经过多年的发展，韩漫之家已经成为国内领先的免费韩漫阅读平台，拥有超过10万部漫画资源和千万级别的用户群体。但我们不忘初心，始终坚持为读者提供最好的漫画阅读服务。
                </p>
              </div>
              <div className="relative rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cozy%20team%20workspace%20creative%20office%20with%20comic%20posters%20on%20wall%20people%20collaborating%20warm%20lighting%20modern%20creative%20studio%20atmosphere%20clean%20composition%20warm%20tones&width=700&height=500&seq=about-brand&orientation=landscape"
                  alt="韩漫之家团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center mb-14">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300"></div>
              <div className="flex flex-col gap-10">
                {milestones.map((ms, idx) => (
                  <div key={ms.year} className={`relative flex items-start gap-6 md:gap-10 ${
                    idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}>
                    <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                      <div className={`p-5 rounded-lg bg-background-50 ${
                        idx % 2 === 0 ? 'md:mr-8' : 'md:ml-8'
                      }`}>
                        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-2 whitespace-nowrap">
                          {ms.year}
                        </span>
                        <h3 className="font-heading text-lg font-bold text-foreground-900">{ms.title}</h3>
                        <p className="mt-1 text-sm text-foreground-500 leading-relaxed">{ms.description}</p>
                      </div>
                    </div>
                    <div className="hidden md:flex flex-1"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 mb-3">
                <span className="w-6 h-6 flex items-center justify-center bg-accent-100 rounded">
                  <i className="ri-double-quotes-l text-accent-500 text-xs"></i>
                </span>
                <span className="text-xs font-medium text-accent-600 uppercase tracking-wide">用户口碑</span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                用户信赖与认可
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.id} className="p-6 rounded-lg bg-background-100">
                  <div className="flex items-center gap-3 mb-4">
                    <img src={t.avatar} alt={t.userName} className="w-11 h-11 rounded-full object-cover" />
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{t.userName}</div>
                      <div className="text-xs text-foreground-400">{t.role}</div>
                    </div>
                  </div>
                  <div className="flex gap-0.5 mb-3">
                    {Array.from({ length: t.rating }).map((_, j) => (
                      <span key={j} className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-400 text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                商务合作
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
                韩漫之家诚邀各类合作伙伴，共同拓展漫画内容生态，为读者带来更丰富的阅读体验
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
              <div className="p-6 rounded-lg bg-background-50 text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto bg-accent-100 rounded-full">
                  <i className="ri-group-line text-accent-500 text-xl"></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4 mb-2">内容合作</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  欢迎韩国漫画平台、漫画作者和版权方与我们合作，将优质漫画内容带给中文读者。
                </p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto bg-primary-100 rounded-full">
                  <i className="ri-advertisement-line text-primary-500 text-xl"></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4 mb-2">广告投放</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  平台月活用户超千万，精准覆盖漫画爱好者群体，提供多样化的广告合作方案。
                </p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto bg-secondary-100 rounded-full">
                  <i className="ri-lightbulb-flash-line text-secondary-500 text-xl"></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4 mb-2">技术合作</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  探索AI推荐、阅读器优化等技术创新合作，共同提升漫画阅读体验。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-secondary-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                联系我们
              </h2>
              <p className="mt-3 text-sm text-foreground-500">有任何问题或合作意向，欢迎与我们联系</p>
            </div>
            <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-5 mb-12">
              <div className="p-6 rounded-lg bg-background-50 text-center">
                <span className="w-10 h-10 flex items-center justify-center mx-auto bg-primary-100 rounded-full">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4 mb-1">客服邮箱</h3>
                <p className="text-sm text-foreground-500">hello@dnchemical.com</p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 text-center">
                <span className="w-10 h-10 flex items-center justify-center mx-auto bg-accent-100 rounded-full">
                  <i className="ri-briefcase-4-line text-accent-500 text-lg"></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4 mb-1">商务合作</h3>
                <p className="text-sm text-foreground-500">hello@dnchemical.com</p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 text-center">
                <span className="w-10 h-10 flex items-center justify-center mx-auto bg-secondary-100 rounded-full">
                  <i className="ri-map-pin-line text-secondary-500 text-lg"></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4 mb-1">公司地址</h3>
                <p className="text-sm text-foreground-500">中国上海市浦东新区</p>
              </div>
            </div>

            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
              常见问题
            </h2>
            <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="p-5 rounded-lg bg-background-50">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">韩漫之家是免费的吗？</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  是的，韩漫之家所有漫画资源均为免费阅读，用户无需付费即可畅享10万+高清韩漫资源。
                </p>
              </div>
              <div className="p-5 rounded-lg bg-background-50">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">漫画更新频率如何？</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  韩漫之家每日更新300+章节，热门漫画持续追更，确保读者第一时间看到最新内容。
                </p>
              </div>
              <div className="p-5 rounded-lg bg-background-50">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">支持哪些设备阅读？</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  支持电脑、平板、手机等多种设备。下拉式阅读设计让手机阅读体验特别流畅。
                </p>
              </div>
              <div className="p-5 rounded-lg bg-background-50">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">如何联系客服？</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  发送邮件至 hello@dnchemical.com，我们提供7×24小时在线服务，工作日2小时内回复。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}